/**
 * OnboardingPage — wraps the OnboardingWizard.
 * Sprint 2 / TASK 0-2 of docs/SPRINT2_WORK_ORDER.md.
 *
 * This page renders FULL-SCREEN with no sidebar, no top nav (the wizard's
 * PageRampShell owns its own minimal top/bottom bars).
 */

import React from 'react';

import OnboardingWizard from '../modules/onboarding/OnboardingWizard';

export interface OnboardingPageProps {
  /** Called when onboarding completes successfully. The router uses this to
   *  push the user to /agent. */
  onComplete: () => void;
}

const OnboardingPage: React.FC<OnboardingPageProps> = ({ onComplete }) => (
  <OnboardingWizard onComplete={onComplete} />
);

export default OnboardingPage;
